import { mockBuilder } from '../../utils/builderHelper.es.js';
import { aPrice } from '../Price.mock.es.js';
import '../../enums/billing/AccountGlobalStatusEnum.es.js';
import '../../enums/billing/AccountingStatusEnum.es.js';
import '../../enums/billing/AssetPurchaseFormatEnum.es.js';
import '../../enums/billing/AssetPurchaseUnavailableCodeEnum.es.js';
import '../../enums/billing/BillingSystemEnum.es.js';
import '../../enums/billing/CreditKindEnum.es.js';
import '../../enums/billing/InvoiceStatusEnum.es.js';
import '../../enums/billing/DiscountTypeEnum.es.js';
import '../../enums/billing/PlanFrequencyEnum.es.js';
import '../../enums/billing/ServiceOffersKindEnum.es.js';
import '../../enums/billing/ServiceStatusEnum.es.js';
import '../../enums/billing/SubscriptionStatusEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTypeEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTimingEnum.es.js';
import '../../enums/billing/SubscriptionServiceOfferEnum.es.js';
import '../../enums/billing/BillingCommitmentEnum.es.js';
import '../../enums/collaboration/ActorEnum.es.js';
import '../../enums/collaboration/EntityTypeEnum.es.js';
import '../../enums/AppHomePageEnum.es.js';
import '../../enums/ApplicationEnum.es.js';
import '../../enums/CreditCardEnum.es.js';
import '../../enums/DollarSignCurrenciesEnum.es.js';
import '../../enums/DownloadBinStatusEnum.es.js';
import '../../enums/ExternalTypeEnum.es.js';
import '../../enums/FeatureEnum.es.js';
import '../../enums/FeatureFlagEnum.es.js';
import '../../enums/FileSelectionSourceEnum.es.js';
import '../../enums/GenresEnum.es.js';
import '../../enums/IntensityEnum.es.js';
import '../../enums/InternalErrorEnum.es.js';
import '../../enums/LibraryItemEnum.es.js';
import '../../enums/MasteringStyleEnum.es.js';
import '../../enums/MfeApplicationEnum.es.js';
import '../../enums/NotificationTypeEnum.es.js';
import '../../enums/PaymentCycleEnum.es.js';
import '../../enums/PaymentMethodEnum.es.js';
import '../../enums/ProofOfRightsEnums.es.js';
import '../../enums/RegexPatternsEnum.es.js';
import '../../enums/ReleaseContributorRoleEnum.es.js';
import '../../enums/ReleaseGlobalStateEnum.es.js';
import '../../enums/ReleaseLanguagesEnum.es.js';
import { ReleasePayoutStatusEnum } from '../../enums/ReleasePayoutStatusEnum.es.js';
import { ReleasePayoutGlobalStatusEnum } from '../../enums/ReleasePayoutGlobalStatusEnum.es.js';
import '../../enums/ReleaseStateEnum.es.js';
import '../../enums/ServiceProviderStateEnum.es.js';
import '../../enums/ReleaseStoreCategoryEnum.es.js';
import '../../enums/ReleaseStoreEnum.es.js';
import '../../enums/ReleaseTerritoriesEnum.es.js';
import '../../enums/ReleaseParentalWarningEnum.es.js';
import '../../enums/SessionFlagsEnum.es.js';
import '../../enums/ShareReactionTypeEnum.es.js';
import '../../enums/SocialNetworksEnum.es.js';
import '../../enums/StateEnum.es.js';
import '../../enums/TrackTypeEnum.es.js';
import '../../enums/UnavailabilityEnum.es.js';
import '../../enums/UserInteractionSourceEnum.es.js';
import '../../enums/ZeroDecimalCurrenciesEnum.es.js';
import '../../enums/NoiseReductionLevelEnum.es.js';
import '../../enums/ReleaseDspsEnum.es.js';
import '../../enums/ReleaseDspStatusEnum.es.js';
import '../../enums/ProjectsCallSourceTypesEnum.es.js';
import '../../enums/LibraryItemTypeEnum.es.js';
import '../../enums/PendingItemStateEnum.es.js';
import '../../enums/MonetizationEligibilityStateEnum.es.js';
import '../../enums/CoverSongOptionsEnum.es.js';
import '../../enums/LanguagesEnum.es.js';
import '../../enums/LocalesEnum.es.js';
import { ReleasePayoutRecipient, ReleasePayout } from './ReleasePayout.es.js';

/** @module Mocks */ /** typedoc */
function aReleasePayoutRecipient() {
    return mockBuilder(new ReleasePayoutRecipient())
        .withAmount(aPrice().withValue(10.0))
        .withFee(aPrice().withValue(0.5))
        .withEmail('give-me-money@landr.com')
        .withStatus(ReleasePayoutStatusEnum.Processing)
        .withGlobalStatus(ReleasePayoutGlobalStatusEnum.Pending);
}
function aReleasePayout() {
    return mockBuilder(new ReleasePayout())
        .withId('payout-1')
        .withCreationTime('2017-09-12T12:00:00.0000Z')
        .withRecipients([aReleasePayoutRecipient()]);
}
function aPayoutRequest() {
    return aReleasePayout()
        .withId(null)
        .withRecipients([
        aReleasePayoutRecipient().withFee(null).withEmail(null).withStatus(null).withGlobalStatus(null),
    ]);
}
function aPreparePayoutResponse() {
    const payoutResponse = aPayoutRequest();
    payoutResponse.recipients[0].withFee(aPrice().withValue(0.5));
    return payoutResponse;
}

export { aPayoutRequest, aPreparePayoutResponse, aReleasePayout, aReleasePayoutRecipient };
